/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client.


/*
 * EXPORTS
 */
export default gql`
mutation FallbackRouteDelete($routeId: ID!) {
    FallbackRouteDelete(routeId: $routeId) {
        message
        status
    }
} 
`

